export const formPersonalValues = (data = {}) => ({
  vendor_code: data?.vendor_code ?? data ?? "",
  vendor_name: data?.vendor_name ?? "",
  vendor_Foto: data?.foto ?? "",
});
  